import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-filter"
export default class extends Controller {
  static targets = ["form", "input", "clear"]

  connect() {
    this.toggle()
  }

  // Auto-submit form when country selection changes
  change() {
    if (this.hasFormTarget) this.formTarget.submit()
  }

  onInput() {
    this.toggle()
  }

  toggle() {
    const hasText = (this.inputTarget?.value || "").trim().length > 0
    if (this.hasClearTarget) {
      this.clearTarget.classList.toggle("hidden", !hasText)
    }
  }

  clear() {
    if (!this.hasInputTarget) return
    this.inputTarget.value = ""
    this.toggle()
    // Optionally submit to clear results filter
    if (this.hasFormTarget) this.formTarget.submit()
  }
}
